export const expectedErrorTextForFailedSignIn = 'Sign In Failed: incorrect email or password.';
export const tooManyFailuresMessage = 'Too many failures. Sign in to resolve the issue.';
export const internalServerErrorMessage = 'ERROR: Internal Server Error';
export const unknownErrorMessage = 'ERROR: an unknown error has occured';
export const failedToSendEmailVerificationMessage =
  'ERROR: failed to send email verification token';
